/**
 * Rondoshare only operates in Czechia, so the country field is an enum with a single allowed
 * value: the ISO-3166 alpha-2 code, stored verbatim so Stripe can consume it directly.
 */
export const COUNTRY_CODES = ['CZ'] as const;

export type CountryCode = typeof COUNTRY_CODES[number];

export const DEFAULT_COUNTRY: CountryCode = 'CZ';

/**
 * Human-readable country name used when the code is embedded in a Mapy.com geocoding query,
 * where a bare ISO code reads badly and geocodes worse.
 */
const GEOCODE_NAMES: Record<CountryCode, string> = {
  CZ: 'Česká republika',
};

export function isCountryCode(value: string | null | undefined): value is CountryCode {
  return COUNTRY_CODES.includes(value as CountryCode);
}

export function countryGeocodeName(country: string): string {
  return isCountryCode(country) ? GEOCODE_NAMES[country] : country;
}

/** Translation key for the option label of a country code. */
export function countryLabelKey(country: CountryCode): string {
  return `country.${country}`;
}
